/**
 * Defines content reader widget configuration
 */
export interface ContentReaderConfiguration {
  /** Content reader widget mode depends on number of contents it has. */
  readerMode: ContentReaderMode
  /** Content Ids listed in array format */
  contentIdArray: string[]
  /** Content type array */
  contentTypeArray: string[]
  /** Exalead query string to fetch all contents in widget */
  refineUsingQuery: string
  /** Widget Id */
  widgetId: string
  /** True if widget is in read only mode */
  isReadOnly: boolean
}

/**
 * Drop zones that are displayed when a conetent is dragged on content reader widget
 */
export interface IZoneData {
  /** Icon corresponding to drop zone */
  fonticon: string
  /** Drop zone i18n key name */
  text: string
  /** Is true when dragged content is hovered on the drop zone. */
  highlight: boolean
  /** Drop zone name */
  zone: ContentReaderDropZone
}

/**
 * Content raeder app can be in any of folowing modes depending on number of
 * contents it has in it.
 */
export enum ContentReaderMode {
  SINGLE_CONTENT = 'single-content',
  MULTI_CONTENT = 'multi-content',
  NO_CONTENT = 'no-content',
}

/**
 * Drop zones
 */
export enum ContentReaderDropZone {
  ADD = 'add',
  REPLACE = 'replace',
  REMOVE = 'remove',
}
